class faqBlock extends HTMLElement {
    constructor() {
      super();
    }
    connectedCallback() {
      const itemWrapper = this.querySelectorAll('.item_wrapper'); 
      itemWrapper.forEach((item, index) => {
        const title = item.querySelector('.item_heading');
        const content = item.querySelector('.item_content');
        title.addEventListener('click', () => {
            item.classList.toggle('active');
 
            if (item.classList.contains('active')) {
                content.style.maxHeight = content.scrollHeight + 'px';
            } else {
                content.style.maxHeight = null;
            }
 
            
            itemWrapper.forEach(otherItem => {
                if (otherItem !== item && otherItem.classList.contains('active')) {
                    otherItem.classList.remove('active');
                    otherItem.querySelector('.item_content').style.maxHeight = null;
                }
            });
        });
 
       if (index === 0) {
            item.classList.add('active');
            content.style.maxHeight = content.scrollHeight + 'px';
        }
      });     
    };
  }
  customElements.define('faq-block', faqBlock);